"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function () {
    return _AssignedDriverComponent.default;
  }
});

var _AssignedDriverComponent = _interopRequireDefault(require("./AssignedDriver-component"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }